exports.f = Object.getOwnPropertySymbols;


/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/library/modules/_object-gops.js
 ** module id = 308
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/library/modules/_object-gops.js
 ** module id = 308
 ** module chunks = 1
 **/